import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getReports 获取检查报告 list
 * @param {Object} info {per: 每页数据, page: 当前页码, rankField: 进行排序的字段, ranking: 正序或倒序, startTime: 开始时间, endTime: 结束时间}
 * @returns {Object} list {data: table 数据, pagination: 分页信息}
 */
const getReports = (info) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/reports`, {
      params: info,
    })
    .then(checkResponse)
}

/**
 * @function getOneReport 获取单条报告数据
 * @param {Object}  id 当前数据 id
 * @returns {Object} res.data 单条报告信息
 * @returns {Number} res.data.id id
 * @returns {String} res.data.createdAt 创建时间
 * @returns {String} res.data.updatedAt 更新时间
 * @returns {String} res.data.isDelete 是否删除
 * @returns {String} res.data.name 名称
 * @returns {String} res.data.url 文档路径
 * @returns {Number} res.data.issue  期数
 * @returns {String} res.data.expirationDate 截止时间
 * @returns {Number} res.data.refreshState 刷新状态 0-无刷新 1-正刷新
 */
const getOneReport = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/reports/${id}`)
    .then(checkResponse)
}

/**
 * @function refreshReport 刷新报告
 * @param {Object}  id 当前数据 id
 * @returns {String} msg 消息提示
 */
const refreshReport = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/reports/${id}/refresh`)
    .then(checkResponse)
}

const exportFile = (st)=>{
   return axios
    .get(`/api/v1/projects/${getProjectId()}/reports/xiaoxiang/manualExport?st=${st}`)
    .then(checkResponse)
}
const exportAllFile = (params)=>{
   return axios
    .get(`/api/v1/projects/${getProjectId()}/connection/report`,{params})
    .then(checkResponse)
}
export {
  getReports,
  getOneReport,
  refreshReport,
  exportFile,
  exportAllFile
}
